var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"logout"},[_c('main-layout',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',{staticClass:"text-center text-primary"},[_vm._v(" Logging Out... ")])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }